import { render, staticRenderFns } from "./ModalRobux.vue?vue&type=template&id=75c4fb10&scoped=true"
import script from "./ModalRobux.vue?vue&type=script&lang=js"
export * from "./ModalRobux.vue?vue&type=script&lang=js"
import style0 from "./ModalRobux.vue?vue&type=style&index=0&id=75c4fb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c4fb10",
  null
  
)

export default component.exports